<template>
    <div class="relative
                z-50">
        <transition name="fade">
            <div v-if="popup.isVisible && contents"
                 class="fixed
                        w-full
                        h-full
                        z-40
                        inset-0
                        bg-black
                        opacity-75" />
        </transition>

        <transition name="fade">
            <div v-if="popup.isVisible && contents"
                 class="fixed
                        w-full
                        h-full
                        top-0
                        left-0
                        z-50
                        flex
                        justify-center
                        items-center"
                 @click.self.prevent="dismiss()">
                <div class="relative
                        bg-white
                        rounded-md
                        shadow
                        p-4
                        max-w-xl"
                     role="alert">
                    <XButton @on-click="dismiss()" aria-label="Close"/>
                    <div class="border-2
                                p-4
                                rounded-md"
                         :class="colors">
                        <h1 class="text-base mb-2">
                            <IconCircleInfo
                                v-if="icon == 'info'"
                                class="inline"
                            />
                            <IconCircleCheck
                                v-else-if="icon == 'success'"
                                class="inline"
                            />
                            <IconCircleExclamation
                                v-else-if="icon == 'warning'"
                                class="inline"
                            />
                            <IconCircleExclamation
                                v-else-if="icon == 'error'"
                                class="inline"
                            />
                            {{ contents.heading }}
                        </h1>
                        <p class="break-words">{{ contents.subheading }}</p>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import XButton from '@/atoms/XButton'
    import PopupTypes from './types'
    import IconCircleInfo from "@/atoms/icons/IconCircleInfo"
    import IconCircleCheck from "@/atoms/icons/IconCircleCheck"
    import IconCircleExclamation from "@/atoms/icons/IconCircleExclamation"

    export default {
        name: 'Popup',
        components: {
            XButton,
            IconCircleInfo,
            IconCircleCheck,
            IconCircleExclamation,
        },
        props: {},
        computed: {
            ...mapState([
                'popup',
            ]),
            contents () {
                let contents = null

                if (this.popup?.type) {
                    const [NAMESPACE, LEVEL, MESSAGE] = this.popup.type.split('/')
                    contents = PopupTypes[NAMESPACE][LEVEL][MESSAGE]
                    contents.level = LEVEL
                }

                return contents
            },
            icon () {
                let icon = null

                switch (this.contents?.level) {
                case 'INFO':
                    icon = 'info'
                    break
                case 'SUCCESS':
                    icon = 'success'
                    break
                case 'WARNINGS':
                    icon = 'warning'
                    break
                case 'ERRORS':
                    icon = 'error'
                    break
                }

                return icon
            },
            colors () {
                let colors = null

                switch (this.contents?.level) {
                case 'INFO':
                    colors = 'bg-navy-light border-blue text-blue'
                    break
                case 'SUCCESS':
                    colors = 'bg-green-200 border-green-800 text-green-800'
                    break
                case 'WARNINGS':
                    colors = 'bg-yellow-200 border-yellow-800 text-yellow-800'
                    break
                case 'ERRORS':
                    colors = 'bg-red-200 border-red-600 text-red-600'
                    break
                }

                return colors
            },
        },
        methods: {
            ...mapActions([
                'togglePopup',
            ]),
            dismiss () {
                this.togglePopup({})
            },
        },
    }
</script>
